/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React from "react";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { WindowDimensions } from "./Interfaces";

export function useQuery(): URLSearchParams {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function getWindowDimensions(): WindowDimensions {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
}

export const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
};
